module.exports = __webpack_public_path__ + "img/New Customer.9fb09d71.svg";